// Lucide icon: user (https://lucide.dev/icons/user)
import { User } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconUser = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <User />
    </IconComponentStyled>
  )
}
